import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback, ProtectedRoute } from "@/components/AuthGuards";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import SearchPage from "@/pages/SearchPage";
import HistoryPage from "@/pages/HistoryPage";
import Dashboard from "@/pages/shop/Dashboard";
import WorkOrders from "@/pages/shop/WorkOrders";
import WorkOrderDetail from "@/pages/shop/WorkOrderDetail";
import PrintWorkOrder from "@/pages/shop/PrintWorkOrder";
import Customers from "@/pages/shop/Customers";
import Inventory from "@/pages/shop/Inventory";
import Technicians from "@/pages/shop/Technicians";
import Assistant from "@/pages/shop/Assistant";
import Settings from "@/pages/shop/Settings";
import Billing from "@/pages/shop/Billing";
import Staff from "@/pages/shop/Staff";
import Admin from "@/pages/shop/Admin";
import JoinShop from "@/pages/JoinShop";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

const Shell = ({ children, roles }) => <ProtectedRoute roles={roles}><AppShell>{children}</AppShell></ProtectedRoute>;

const MGR = ["owner", "service_writer"];
const SHELL_ROUTES = [
  ["/app", Dashboard],
  ["/app/work-orders", WorkOrders],
  ["/app/work-orders/:id", WorkOrderDetail],
  ["/app/customers", Customers, MGR],
  ["/app/inventory", Inventory, MGR],
  ["/app/technicians", Technicians, MGR],
  ["/app/assistant", Assistant],
  ["/app/parts", SearchPage],
  ["/app/history", HistoryPage],
  ["/app/settings", Settings, ["owner"]],
  ["/app/billing", Billing],
  ["/app/staff", Staff, ["owner"]],
  ["/app/admin", Admin, ["admin"]],
];

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/join/:token" element={<JoinShop />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      {SHELL_ROUTES.map(([path, C, roles]) => <Route key={path} path={path} element={<Shell roles={roles}><C /></Shell>} />)}
      <Route path="/app/work-orders/:id/print" element={<ProtectedRoute roles={MGR}><PrintWorkOrder /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
